import ApexCharts, { ApexOptions } from 'apexcharts';
import { FC, useEffect, useRef } from 'react';

type IProps = {
  readonly data?: {
    worker_type: string;
    percentage: number;
    quantity: number;
  }[];
};

const workerTypeLabels: Record<string, string> = {
  'TRANG-THAI-TUYEN-DUNG-NLD-01': 'Chưa phân loại',
  'TRANG-THAI-TUYEN-DUNG-NLD-02': 'Tiềm năng',
  'TRANG-THAI-TUYEN-DUNG-NLD-03': 'Chờ đến',
  'TRANG-THAI-TUYEN-DUNG-NLD-04': 'Không tiềm năng',
  'TRANG-THAI-TUYEN-DUNG-NLD-05': 'Thất bại (Không đến)',
  'TRANG-THAI-TUYEN-DUNG-NLD-06': 'Không đủ tiêu chuẩn',
  'TRANG-THAI-TUYEN-DUNG-NLD-07': 'Nhà máy thừa SL',
  'TRANG-THAI-TUYEN-DUNG-NLD-08': 'Được vào làm',
  'TRANG-THAI-TUYEN-DUNG-NLD-09': 'Đã nghỉ việc',
};

const PieChartWorkerType: FC<IProps> = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const options: ApexOptions = {
      chart: {
        type: 'pie',
        height: 350,
      },
      labels: data.map((item) => workerTypeLabels[item.worker_type] || item.worker_type),
      series: data.map((item) => item.quantity || item.percentage),
      tooltip: {
        y: {
          formatter: function (val, opts) {
            const item = data[opts.seriesIndex];
            return `${item.quantity ?? val} NLĐ (${item.percentage}%)`;
          },
        },
      },
      legend: {
        position: 'bottom',
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: number, opts) {
          const item = data[opts.seriesIndex];
          return `${item.percentage}%`;
        },
      },
    };

    const chart = new ApexCharts(chartRef.current, options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [data]);

  if (!data || data.length === 0) {
    return <div className="text-center text-muted">Không có dữ liệu</div>;
  }

  return <div ref={chartRef} className="pt-5 d-flex justify-content-center" id="pie-chart-worker-type" />;
};

export { PieChartWorkerType };
